import { createAction, props } from "@ngrx/store";
import { ICreateDeviceLocationRequest, IDeviceLocation, IUpdateDeviceLocationRequest } from "src/app/devices/models/device-location";

// Get Device Locations
export const getDeviceLocationsByCompany = createAction(
    '[DeviceLocations] Get Device Locations',
    props<{ companyId: string }>()
);

export const getDeviceLocationsByCompanySuccess = createAction(
    '[DeviceLocations] Get Device Locations success', 
    props<{ deviceLocations: IDeviceLocation[] }>()
);

export const getDeviceLocationsByCompanyFailure = createAction(
    '[DeviceLocations] Get Device Locations failure',
    props<{error: string}>()
);

// Create Device Location
export const createDeviceLocation = createAction(
    '[DeviceLocations] Create Device Location',
    props<{ deviceLocation: ICreateDeviceLocationRequest }>()
);

export const createDeviceLocationSuccess = createAction(
    '[DeviceLocations] Create Device Location success',
    props<{ deviceLocation: IDeviceLocation }>()
);

export const createDeviceLocationFailure = createAction(
    '[DeviceLocations] Create Device Location failure',
    props<{error: string}>()
);

// Update Device Location
export const updateDeviceLocation = createAction(
    '[DeviceLocations] Update Device Location',
    props<{ deviceLocation: IUpdateDeviceLocationRequest }>()
);

export const updateDeviceLocationSuccess = createAction(
    '[DeviceLocations] Update Device Location success',
    props<{ deviceLocation: IDeviceLocation }>()
);

export const updateDeviceLocationFailure = createAction(
    '[DeviceLocations] Update Device Location failure',
    props<{error: string}>()
);

// Delete Device Location
export const deleteDeviceLocation = createAction(
    '[DeviceLocations] Delete Device Location',
    props<{id: string}>()
);

export const deleteDeviceLocationSuccess = createAction(
    '[DeviceLocations] Delete Device Location success',
    props<{id: string}>()
);

export const deleteDeviceLocationFailure = createAction(
    '[DeviceLocations] Delete Device Location failure',
    props<{error: string}>()
);

// Clear Device Location Store
export const clearDeviceLocations = createAction(
    '[Device Locations] Clear Device Locations'
);
